// atom (컴포넌트 최소 단위 요소)

// layout
import Box from './layout/Box/Box';
import Center from './layout/Center/Center';
import HStack from './layout/HStack/HStack';
import VStack from './layout/VStack/VStack';
import ZStack from './layout/ZStack/ZStack';

// feedback
import Spinner from './feedback/Spinner/Spinner';

// form
import Button from './form/Button/Button';
import Input from './form/Input/Input';

// media
import Image from './media/Image/Image';

// reactNative
import ScrollView from './reactNative/ScrollView/ScrollView';
// import Share from './reactNative/Share/Share';

// typegraphy
import Text from './typography/Text/Text';

// import PanWithoutZoomDivision from './reactnative/PanWithoutZoomDivision/PanWithoutZoomDivision';

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역

// =================================================================================================
// 상수
// =================================================================================================

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  layout: {
    Box: Box,
    Center: Center,
    HStack: HStack,
    VStack: VStack,
    ZStack: ZStack,
  },
  feedback: {
    Spinner: Spinner,
  },
  form: {
    Button: Button,
    Input: Input,
  },
  media: {
    Image: Image,
  },
  reactNative: {
    ScrollView: ScrollView,
    // Share: Share,
  },
  typograpgy: {
    Text: Text,
  },

  // reactnative: {
  //   PanWithoutZoomDivision: PanWithoutZoomDivision,
  // },
};
